module.exports = __webpack_public_path__ + "img/stone1.aa9040c5.jpg";